(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  // Optimized: Early return, throttled scroll, event delegation
  (function() {
    'use strict';
    const carousel = document.querySelector('.best-sellers-section__products--carousel');
    if (!carousel) return;

    const prevBtn = carousel.parentElement.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.parentElement.querySelector('[data-carousel-next]');
    if (!prevBtn && !nextBtn) return;

    const updateButtons = function() {
      if (prevBtn) prevBtn.disabled = carousel.scrollLeft <= 0;
      if (nextBtn) {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        nextBtn.disabled = carousel.scrollLeft >= maxScroll - 1;
      }
    };

    // Use event delegation for buttons
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
      if (!btn || !btn.closest('.best-sellers-section__products--carousel').parentElement.contains(btn)) return;

      const isPrev = btn.hasAttribute('data-carousel-prev');
      const scrollAmount = carousel.clientWidth * 0.8;

      carousel.scrollBy({
        left: isPrev ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });

      // Update buttons after scroll animation
      setTimeout(updateButtons, 300);
    });

    // Throttled scroll handler for button updates
    let ticking = false;
    const handleScroll = function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateButtons();
          ticking = false;
        });
        ticking = true;
      }
    };

    carousel.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });

    // Initial button state
    updateButtons();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Cart page functionality with validation and event delegation
  (function() {
    'use strict';
    
    const cartForm = document.getElementById('cart-form');
    if (!cartForm) return;
    
    // Use AbortController for proper event cleanup
    const abortController = new AbortController();
    const signal = abortController.signal;
    
    /**
     * Validate quantity input
     */
    function validateQuantity(value) {
      const qty = parseInt(value, 10);
      if (isNaN(qty) || qty < 0) {
        return { valid: false, error: 'Quantity must be a number' };
      }
      if (qty < 0) {
        return { valid: false, error: 'Quantity cannot be negative' };
      }
      if (qty > 999) {
        return { valid: false, error: 'Quantity cannot exceed 999' };
      }
      return { valid: true, value: qty };
    }
    
    /**
     * Update cart with validation
     */
    function updateCart() {
      if (!cartForm) return;
      
      // Validate all quantity fields before submission
      const quantityFields = cartForm.querySelectorAll('.cart-item__quantity-field');
      let isValid = true;
      
      quantityFields.forEach(field => {
        const validation = validateQuantity(field.value);
        if (!validation.valid) {
          isValid = false;
          field.setCustomValidity(validation.error);
          field.reportValidity();
        } else {
          field.setCustomValidity('');
          field.value = validation.value;
        }
      });
      
      if (isValid) {
        cartForm.submit();
      }
    }

    // Use event delegation for quantity controls (better performance, handles dynamic content)
    cartForm.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-quantity-decrease], [data-quantity-increase]');
      if (!btn) return;
      
      const field = btn.parentElement.querySelector('.cart-item__quantity-field');
      if (!field) return;
      
      const validation = validateQuantity(field.value);
      if (!validation.valid) {
        field.setCustomValidity(validation.error);
        field.reportValidity();
        return;
      }
      
      const current = validation.value;
      
      if (btn.hasAttribute('data-quantity-decrease')) {
        if (current > 1) {
          field.value = current - 1;
          updateCart();
        } else if (current === 1) {
          // Remove item
          const cartItem = btn.closest('[data-cart-item]');
          const removeLink = cartItem ? cartItem.querySelector('.cart-item__remove') : null;
          if (removeLink) {
            window.location.href = removeLink.href;
          }
        }
      } else if (btn.hasAttribute('data-quantity-increase')) {
        if (current < 999) {
          field.value = current + 1;
          updateCart();
        } else {
          field.setCustomValidity('Quantity cannot exceed 999');
          field.reportValidity();
        }
      }
    }, { signal });

    // Validate quantity fields on change
    cartForm.addEventListener('change', function(e) {
      if (e.target.classList.contains('cart-item__quantity-field')) {
        const validation = validateQuantity(e.target.value);
        if (!validation.valid) {
          e.target.setCustomValidity(validation.error);
          e.target.reportValidity();
        } else {
          e.target.setCustomValidity('');
          e.target.value = validation.value;
          updateCart();
        }
      }
    }, { signal });
    
    // Validate on input to provide immediate feedback
    cartForm.addEventListener('input', function(e) {
      if (e.target.classList.contains('cart-item__quantity-field')) {
        const validation = validateQuantity(e.target.value);
        if (!validation.valid) {
          e.target.setCustomValidity(validation.error);
        } else {
          e.target.setCustomValidity('');
        }
      }
    }, { signal });
    
    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
      abortController.abort();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-sidebar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Handle sort select change
    const sortSelect = document.querySelector('[data-collection-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        if (this.value) {
          window.location.href = this.value;
        }
      });
    }

    // Handle quick add form clicks to prevent event bubbling
    const quickAddForms = document.querySelectorAll('[data-quick-add-form]');
    quickAddForms.forEach(function(form) {
      form.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  // In-Grid Variant Switching with Event Delegation
  (function() {
    'use strict';

    // Image cache for preloading
    const imageCache = new Map();

    // Store default images for each product card
    const defaultImages = new Map();
    function initializeProductCards() {
      document.querySelectorAll('.collection-product-card').forEach(card => {
        const image = card.querySelector('.collection-product-card__image img');
        if (image && image.src) {
          const closestEl = card.closest('[data-product-id]');
          const productId = card.getAttribute('data-product-id') || 
                           (closestEl ? closestEl.getAttribute('data-product-id') : null);
          if (productId) {
            defaultImages.set(productId, {
              src: image.src,
              alt: image.alt
            });
          }
        }
        
        // Preload variant images from JSON map
        const jsonScript = card.querySelector('.variant-image-map');
        if (jsonScript) {
          try {
            const variantMap = JSON.parse(jsonScript.textContent);
            variantMap.options.forEach(option => {
              option.values.forEach(valueData => {
                if (valueData.image_url && !imageCache.has(valueData.image_url)) {
                  const img = new Image();
                  img.src = valueData.image_url;
                  imageCache.set(valueData.image_url, img);
                }
              });
            });
          } catch (e) {
            // Failed to parse variant image map
          }
        }
      });
    }
    
    // Handle swatch interaction (hover or click)
    function handleSwatchInteraction(e) {
      // Ensure we have an Element node (not text node)
      const target = e.target.nodeType === Node.ELEMENT_NODE ? e.target : e.target.parentElement;
      if (!target) {
        return;
      }
      
      const swatch = target.closest('.collection-product-card__swatch');
      if (!swatch) return;
      
      const productCard = swatch.closest('.collection-product-card');
      if (!productCard) return;
      
      const imageWrapper = productCard.querySelector('.collection-product-card__image-wrapper');
      const image = imageWrapper ? imageWrapper.querySelector('.collection-product-card__image img') : null;
      
      if (!image) return;
      
      // Get image URL from data attribute or JSON map
      let imageUrl = swatch.getAttribute('data-image-url');
      let imageAlt = swatch.getAttribute('data-image-alt');
      
      // Fallback: Try to get from JSON map
      if (!imageUrl) {
        const jsonScript = productCard.querySelector('.variant-image-map');
        if (jsonScript) {
          try {
            const variantMap = JSON.parse(jsonScript.textContent);
            const optionValue = swatch.getAttribute('data-option-value') || 
                              swatch.getAttribute('aria-label');
            if (variantMap.options && variantMap.options[0] && variantMap.options[0].values) {
              variantMap.options[0].values.forEach(valueData => {
              if (valueData.value_handle === optionValue || valueData.value === optionValue) {
                imageUrl = valueData.image_url;
                imageAlt = valueData.image_alt || imageAlt;
              }
            });
            }
          } catch (e) {
            // Failed to parse variant map
          }
        }
      }
      
      if (imageUrl && image.src !== imageUrl) {
        // Smooth image swap
        image.style.transition = 'opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
        image.style.opacity = '0.7';
        
        requestAnimationFrame(() => {
          image.src = imageUrl;
          if (imageAlt) image.alt = imageAlt;
          
          // Update srcset for responsive images
          const srcsetUrl = imageUrl.replace('width=600', 'width=1200');
          image.srcset = imageUrl + ' 600w, ' + srcsetUrl + ' 1200w';
          
          // Check if image is cached
          const cachedImg = imageCache.get(imageUrl);
          if (cachedImg && cachedImg.complete) {
            image.style.opacity = '1';
          } else {
            image.onload = () => {
              image.style.opacity = '1';
            };
            image.onerror = () => {
              image.style.opacity = '1';
            };
          }
        });
      }
    }
    
    // Revert to default image
    function revertToDefaultImage(e) {
      // Ensure we have an Element node (not text node)
      const target = e.target.nodeType === Node.ELEMENT_NODE ? e.target : e.target.parentElement;
      if (!target) {
        return;
      }
      
      const swatch = target.closest('.collection-product-card__swatch');
      if (!swatch) return;
      
      const productCard = swatch.closest('.collection-product-card');
      if (!productCard) return;
      
      const imageWrapper = productCard.querySelector('.collection-product-card__image-wrapper');
      const image = imageWrapper ? imageWrapper.querySelector('.collection-product-card__image img') : null;
      
      if (!image) return;
      
      // Get default image from stored map or JSON
          const productIdEl = productCard.querySelector('[data-product-id]');
          const productId = productCard.getAttribute('data-product-id') || 
                       (productIdEl ? productIdEl.getAttribute('data-product-id') : null);
      let defaultImage = defaultImages.get(productId);
      
      if (!defaultImage) {
        const jsonScript = productCard.querySelector('.variant-image-map');
        if (jsonScript) {
          try {
            const variantMap = JSON.parse(jsonScript.textContent);
            defaultImage = {
              src: variantMap.default_image,
              alt: ''
            };
          } catch (e) {
            return;
          }
        } else {
          return;
        }
      }
      
      if (defaultImage && image.src !== defaultImage.src) {
        image.style.transition = 'opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
        image.style.opacity = '0.7';
        
        requestAnimationFrame(() => {
          image.src = defaultImage.src;
          if (defaultImage.alt) image.alt = defaultImage.alt;
          image.style.opacity = '1';
        });
      }
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProductCards);
    } else {
      initializeProductCards();
    }
    
    // Desktop: Hover listener (event delegation)
    document.addEventListener('mouseenter', function(e) {
      if (window.innerWidth >= 991) {
        // Check if target is an Element node before calling closest
        const target = e.target.nodeType === Node.ELEMENT_NODE ? e.target : e.target.parentElement;
        if (target && target.closest('.collection-product-card__swatch')) {
          handleSwatchInteraction(e);
        }
      }
    }, true);
    
    // Desktop: Mouseout to revert (event delegation)
    document.addEventListener('mouseleave', function(e) {
      if (window.innerWidth >= 991) {
        // Check if target is an Element node before calling closest
        const target = e.target.nodeType === Node.ELEMENT_NODE ? e.target : e.target.parentElement;
        if (target && target.closest('.collection-product-card__swatch')) {
          revertToDefaultImage(e);
        }
      }
    }, true);
    
    // Mobile/Click: Tap listener (event delegation)
    document.addEventListener('click', function(e) {
      // Check if target is an Element node before calling closest
      const target = e.target.nodeType === Node.ELEMENT_NODE ? e.target : e.target.parentElement;
      if (target && target.closest('.collection-product-card__swatch')) {
        handleSwatchInteraction(e);
      }
    });
    
    // Touch support for mobile
    document.addEventListener('touchstart', function(e) {
      // Check if target is an Element node before calling closest
      const target = e.target.nodeType === Node.ELEMENT_NODE ? e.target : e.target.parentElement;
      if (target && target.closest('.collection-product-card__swatch')) {
        handleSwatchInteraction(e);
      }
    }, { passive: true });
  })();

  // Quick View initialization for collection page
  // Use AbortController for event listener cleanup
  var collectionAbortController = new AbortController();
  var collectionSignal = collectionAbortController.signal;

  // The core openQuickView function is now in assets/quick-view.js (shared)
  // This listener handles collection-specific enhancements when Quick View content loads
  document.addEventListener('quickViewContentLoaded', function() {
    const modal = document.querySelector('.quick-view-modal');
    if (!modal) return;
    
    // Reinitialize scripts (this will re-execute the product-gallery-zoom snippet)
    const scripts = modal.querySelectorAll('script');
    scripts.forEach(oldScript => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
    
    // Initialize collection-specific Quick View features
    setTimeout(() => {
      initQuickViewVariants(modal);
      initQuickViewThumbnails(modal);
      // Note: Image zoom is handled by product-gallery-zoom snippet which is re-executed above
    }, 150);
  }, { signal: collectionSignal });

  // Shared variant update function (accessible to both variant select and thumbnail handlers)
  function updateQuickViewVariantDisplay(modal, variantId, variantPrice, variantComparePrice, variantImageUrl) {
    if (!modal) return;
    
    const priceContainer = modal.querySelector('[data-quick-view-price]') ||
                          modal.querySelector('.product-quick-view__price') ||
                          modal.querySelector('.product-info__price');
    
    const imageContainer = modal.querySelector('[data-quick-view-image]') ||
                          modal.querySelector('.product-quick-view__image') ||
                          modal.querySelector('.product-gallery__main') ||
                          modal.querySelector('.product-page__media');
    
    // Update variant display
    // Update price
    if (priceContainer && variantPrice) {
      const priceElement = priceContainer.querySelector('[data-price]') ||
                          priceContainer.querySelector('.product-quick-view__price--sale') ||
                          priceContainer.querySelector('.product-info__price--sale') ||
                          priceContainer.querySelector('span:not(.product-quick-view__price--compare):not(.product-info__price--compare)');
      const comparePriceElement = priceContainer.querySelector('[data-compare-price]') ||
                                 priceContainer.querySelector('.product-quick-view__price--compare') ||
                                 priceContainer.querySelector('.product-info__price--compare');
      
      if (priceElement) {
        // Format price: convert cents to dollars
        const price = (variantPrice / 100).toFixed(2);
        const formattedPrice = '$' + price;
        
        priceElement.textContent = formattedPrice;
        
        // Update compare price
        if (variantComparePrice > variantPrice) {
          let compareElement = comparePriceElement;
          if (!compareElement) {
            compareElement = document.createElement('span');
            compareElement.className = priceContainer.classList.contains('product-quick-view__price') 
              ? 'product-quick-view__price--compare' 
              : 'product-info__price--compare';
            compareElement.setAttribute('data-compare-price', '');
            priceContainer.appendChild(compareElement);
          }
          const comparePrice = (variantComparePrice / 100).toFixed(2);
          compareElement.textContent = '$' + comparePrice;
          compareElement.style.display = '';
          
          if (priceElement.classList) {
            priceElement.classList.add(priceContainer.classList.contains('product-quick-view__price') 
              ? 'product-quick-view__price--sale' 
              : 'product-info__price--sale');
          }
        } else {
          if (comparePriceElement) {
            comparePriceElement.style.display = 'none';
          }
          if (priceElement.classList) {
            priceElement.classList.remove('product-quick-view__price--sale', 'product-info__price--sale');
          }
        }
      }
    }
    
    // Update image
    if (imageContainer && variantImageUrl) {
      const imageElement = imageContainer.querySelector('img') ||
                          imageContainer.querySelector('.product-gallery__image') ||
                          imageContainer.querySelector('.product-quick-view__image-element');
      
      if (imageElement) {
        imageElement.style.transition = 'opacity 0.2s ease';
        imageElement.style.opacity = '0.7';
        
        requestAnimationFrame(() => {
          imageElement.src = variantImageUrl;
          // Update srcset
          const srcsetUrl = variantImageUrl.replace('width=600', 'width=1200');
          imageElement.srcset = variantImageUrl + ' 600w, ' + srcsetUrl + ' 1200w';
          
          imageElement.onload = () => {
            imageElement.style.opacity = '1';
          };
          imageElement.onerror = () => {
            imageElement.style.opacity = '1';
          };
        });
      }
    }
    
    // Update form hidden input
    const form = modal.querySelector('form');
    if (form) {
      let hiddenInput = form.querySelector('input[name="id"]');
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'id';
        form.appendChild(hiddenInput);
      }
      hiddenInput.value = variantId;
    }
  }

  // Quick View Variant Selection Handler
  function initQuickViewVariants(modal) {
    if (!modal) return;
    
    // Get product JSON if available (for product section)
    let productJson = null;
    const productJsonEl = modal.querySelector('script[type="application/json"][id^="ProductJson-"]');
    if (productJsonEl) {
      try {
        productJson = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        // Failed to parse product JSON
      }
    }
    
    // Handle variant select dropdown (product-quick-view section)
    const variantSelect = modal.querySelector('[data-quick-view-variant-select]') ||
                         modal.querySelector('.product-quick-view__variant-select') ||
                         modal.querySelector('#QuickViewVariant-');
    
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        if (!selectedOption) return;
        
        const variantId = this.value;
        const variantPrice = parseInt(selectedOption.getAttribute('data-price') || '0', 10);
        const variantComparePrice = parseInt(selectedOption.getAttribute('data-compare-price') || '0', 10);
        const variantImageUrl = selectedOption.getAttribute('data-image-url');
        
        updateQuickViewVariantDisplay(modal, variantId, variantPrice, variantComparePrice, variantImageUrl);
        
        // Update thumbnails to match selected variant
        const gallery = modal.querySelector('.product-gallery');
        if (gallery) {
          const slides = gallery.querySelectorAll('.product-gallery__slide');
          const thumbnails = gallery.querySelectorAll('.product-gallery__thumbnail');
          
          // Find the slide that matches this variant
          let targetIndex = -1;
          slides.forEach((slide, index) => {
            const variantIds = slide.getAttribute('data-variant-ids');
            if (variantIds) {
              const variantIdArray = variantIds.split(',').map(id => parseInt(id.trim(), 10));
              if (variantIdArray.includes(parseInt(variantId, 10))) {
                targetIndex = index;
              }
            }
          });
          
          // If we found a matching slide, update active states
          if (targetIndex >= 0) {
            thumbnails.forEach(t => t.classList.remove('product-gallery__thumbnail--active'));
            slides.forEach(s => s.classList.remove('product-gallery__slide--active'));
            
            if (thumbnails[targetIndex]) {
              thumbnails[targetIndex].classList.add('product-gallery__thumbnail--active');
            }
            if (slides[targetIndex]) {
              slides[targetIndex].classList.add('product-gallery__slide--active');
            }
          }
        }
      });
    }
    
    // Handle radio button variant selection (product section)
    const optionInputs = modal.querySelectorAll('.product-form__option-input');
    if (optionInputs.length > 0 && productJson) {
      const variantSelectHidden = modal.querySelector('#ProductSelect-') || modal.querySelector('select[name="id"]');
      
      modal.addEventListener('change', function(e) {
        if (!e.target.matches('.product-form__option-input')) return;
        
        // Build selected options array
        const selectedOptions = [];
        optionInputs.forEach(input => {
          if (input.checked) {
            const idMatch = input.id.match(/Option-[\w-]+-(\d+)-/);
            if (idMatch) {
              const optionIndex = parseInt(idMatch[1], 10);
              selectedOptions[optionIndex] = input.value;
            }
          }
        });
        
        // Find matching variant
        const variant = productJson.variants.find(v => {
          if (!v.options || v.options.length !== productJson.options.length) return false;
          return v.options.every((optionValue, index) => {
            const selectedValue = selectedOptions[index];
            if (!selectedValue) return false;
            return selectedValue.trim().toLowerCase() === optionValue.trim().toLowerCase();
          });
        });
        
        if (variant && variantSelectHidden) {
          variantSelectHidden.value = variant.id;
          
          // Get variant image
          let variantImageUrl = null;
          if (variant.featured_media) {
            variantImageUrl = (variant.featured_media.preview_image && variant.featured_media.preview_image.src) || variant.featured_media.src;
          } else if (productJson.featured_media) {
            variantImageUrl = (productJson.featured_media.preview_image && productJson.featured_media.preview_image.src) || productJson.featured_media.src;
          }
          
          updateQuickViewVariantDisplay(modal, variant.id, variant.price, variant.compare_at_price || 0, variantImageUrl);
          
          // Update thumbnails to match selected variant
          const gallery = modal.querySelector('.product-gallery');
          if (gallery) {
            const slides = gallery.querySelectorAll('.product-gallery__slide');
            const thumbnails = gallery.querySelectorAll('.product-gallery__thumbnail');
            
            // Find the slide that matches this variant
            let targetIndex = -1;
            slides.forEach((slide, index) => {
              const variantIds = slide.getAttribute('data-variant-ids');
              if (variantIds) {
                const variantIdArray = variantIds.split(',').map(id => parseInt(id.trim(), 10));
                if (variantIdArray.includes(variant.id)) {
                  targetIndex = index;
                }
              }
            });
            
            // If we found a matching slide, update active states
            if (targetIndex >= 0) {
              thumbnails.forEach(t => t.classList.remove('product-gallery__thumbnail--active'));
              slides.forEach(s => s.classList.remove('product-gallery__slide--active'));
              
              if (thumbnails[targetIndex]) {
                thumbnails[targetIndex].classList.add('product-gallery__thumbnail--active');
              }
              if (slides[targetIndex]) {
                slides[targetIndex].classList.add('product-gallery__slide--active');
              }
            }
          }
        }
      });
    }
  }

  // Quick View Thumbnail Handler
  function initQuickViewThumbnails(modal) {
    if (!modal) return;
    
    const gallery = modal.querySelector('.product-gallery');
    if (!gallery) return;
    
    // Find the modal for zoom
    const imageModal = modal.querySelector('.product-gallery__modal');
    
    // Thumbnail click handler
    gallery.addEventListener('click', function(e) {
      // Handle zoom button clicks first
      const zoomButton = e.target.closest('.product-gallery__zoom');
      if (zoomButton) {
        e.preventDefault();
        e.stopPropagation();
        
        const imageWrapper = zoomButton.closest('.product-gallery__image-wrapper');
        if (!imageWrapper || !imageModal) return;
        
        // Get image index
        const indexStr = imageWrapper.getAttribute('data-image-index');
        if (indexStr === null) return;
        
        const currentModalIndex = parseInt(indexStr, 10);
        if (isNaN(currentModalIndex)) return;
        
        // Update modal to show correct image
        const modalSlides = imageModal.querySelectorAll('.product-gallery__modal-slide');
        modalSlides.forEach((slide, index) => {
          slide.classList.toggle('product-gallery__modal-slide--active', index === currentModalIndex);
        });
        
        // Reset zoom on active image
        const activeSlide = imageModal.querySelector('.product-gallery__modal-slide--active');
        const activeImage = activeSlide ? activeSlide.querySelector('.product-gallery__modal-image') : null;
        if (activeImage) {
          activeImage.style.transform = 'scale(1)';
          activeImage.style.transformOrigin = 'center center';
          activeImage.classList.remove('zoomed');
        }
        
        // Hide header/navbar
        const header = document.querySelector('[data-header]') || document.querySelector('.header, header');
        if (header) header.style.display = 'none';
        // Hide quick view close button
        const quickViewClose = modal.querySelector('.quick-view-modal__close');
        if (quickViewClose) quickViewClose.style.display = 'none';
        
        // Show modal
        imageModal.classList.add('product-gallery__modal--active');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        
        return;
      }
      
      // Check if click is on thumbnail button or image inside it
      const thumb = e.target.closest('.product-gallery__thumbnail');
      if (!thumb) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const indexStr = thumb.getAttribute('data-thumbnail-index');
      if (indexStr === null) return;
      
      const index = parseInt(indexStr, 10);
      if (isNaN(index)) return;
      
      const thumbnails = gallery.querySelectorAll('.product-gallery__thumbnail');
      const slides = gallery.querySelectorAll('.product-gallery__slide');
      const targetSlide = slides[index];
      
      if (!targetSlide) return;
      
      // Update active states
      thumbnails.forEach(t => t.classList.remove('product-gallery__thumbnail--active'));
      slides.forEach(s => s.classList.remove('product-gallery__slide--active'));
      
      thumb.classList.add('product-gallery__thumbnail--active');
      targetSlide.classList.add('product-gallery__slide--active');
      
      // Check if this image is associated with a variant and switch to it
      const variantIds = targetSlide.getAttribute('data-variant-ids');
      if (variantIds) {
        const variantIdArray = variantIds.split(',').map(id => parseInt(id.trim(), 10));
        
        // PRIORITY: Handle radio button variants (product page template)
        const productJsonEl = modal.querySelector('script[type="application/json"][id^="ProductJson-"]');
        if (productJsonEl) {
          try {
            const productJson = JSON.parse(productJsonEl.textContent);
            
            // Find the first available variant that matches
            let matchingVariant = null;
            for (const variantId of variantIdArray) {
              const variant = productJson.variants.find(v => v.id === variantId && v.available);
              if (variant) {
                matchingVariant = variant;
                break;
              }
            }
            
            // If no available variant, use first matching variant
            if (!matchingVariant && variantIdArray.length > 0) {
              matchingVariant = productJson.variants.find(v => v.id === variantIdArray[0]);
            }
            
            if (matchingVariant && matchingVariant.options && productJson.options) {
              // Update variant select first
              const hiddenVariantSelect = modal.querySelector('#ProductSelect-') || 
                                           modal.querySelector('select[name="id"].product-form__variant-select') ||
                                           modal.querySelector('select[name="id"]');
              if (hiddenVariantSelect) {
                hiddenVariantSelect.value = matchingVariant.id;
              }
              
              // Get all option inputs in the modal
              const allOptionInputs = modal.querySelectorAll('.product-form__option-input');
              
              // Update option inputs to match this variant (same as product page)
              matchingVariant.options.forEach((optionValue, optionIndex) => {
                if (optionIndex < productJson.options.length) {
                  // Handle both string and object option structures
                  const optionName = typeof productJson.options[optionIndex] === 'string' 
                    ? productJson.options[optionIndex] 
                    : productJson.options[optionIndex].name;
                  
                  if (optionName) {
                    const nameAttr = 'options[' + optionName + ']';
                    // Find all radio inputs in this option group
                    const groupRadios = modal.querySelectorAll('input.product-form__option-input[name="' + nameAttr + '"]');
                    
                    // First uncheck all in this group to ensure clean state
                    groupRadios.forEach(radio => {
                      radio.checked = false;
                    });
                    
                    // Then find and check the matching input in this group
                    groupRadios.forEach(input => {
                      // Match ID pattern: Option-{sectionId}-{optionIndex}-{valueIndex}
                      const idMatch = input.id.match(/Option-[\w-]+-(\d+)-/);
                      if (idMatch) {
                        const inputOptionIndex = parseInt(idMatch[1], 10);
                        if (inputOptionIndex === optionIndex && 
                            input.value.trim().toLowerCase() === String(optionValue).trim().toLowerCase()) {
                          input.checked = true;
                          // Trigger change event to update UI (same as product page)
                          input.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                      }
                    });
                  }
                }
              });
              
              // Get variant image URL
              let variantImageUrl = null;
              if (matchingVariant.featured_media) {
                variantImageUrl = matchingVariant.featured_media.preview_image?.src || matchingVariant.featured_media.src;
              } else if (productJson.featured_media) {
                variantImageUrl = (productJson.featured_media.preview_image && productJson.featured_media.preview_image.src) || productJson.featured_media.src;
              }
              
              // Update variant display
              updateQuickViewVariantDisplay(modal, matchingVariant.id, matchingVariant.price, matchingVariant.compare_at_price || 0, variantImageUrl);
            }
          } catch (e) {
            // Failed to parse product JSON for thumbnail variant update
          }
        } else {
          // Fallback: Handle dropdown variant select (product-quick-view template)
          const variantSelect = modal.querySelector('[data-quick-view-variant-select]') ||
                               modal.querySelector('.product-quick-view__variant-select') ||
                               modal.querySelector('select[name="id"]');
          
          if (variantSelect && variantIdArray.length > 0) {
            // Find the first available variant that matches
            let matchingVariantId = null;
            let matchingOption = null;
            
            for (let i = 0; i < variantSelect.options.length; i++) {
              const option = variantSelect.options[i];
              const optionVariantId = parseInt(option.value, 10);
              if (variantIdArray.includes(optionVariantId) && !option.disabled) {
                matchingVariantId = optionVariantId;
                matchingOption = option;
                break;
              }
            }
            
            // If no available variant found, use the first matching variant
            if (!matchingVariantId && variantIdArray.length > 0) {
              for (let i = 0; i < variantSelect.options.length; i++) {
                const option = variantSelect.options[i];
                const optionVariantId = parseInt(option.value, 10);
                if (variantIdArray.includes(optionVariantId)) {
                  matchingVariantId = optionVariantId;
                  matchingOption = option;
                  break;
                }
              }
            }
            
            if (matchingVariantId && matchingOption) {
              // Update variant select value
              variantSelect.value = matchingVariantId;
              
              // Get variant data from option attributes
              const variantPrice = parseInt(matchingOption.getAttribute('data-price') || '0', 10);
              const variantComparePrice = parseInt(matchingOption.getAttribute('data-compare-price') || '0', 10);
              const variantImageUrl = matchingOption.getAttribute('data-image-url');
              
              // Update variant display directly
              updateQuickViewVariantDisplay(modal, matchingVariantId, variantPrice, variantComparePrice, variantImageUrl);
              
              // Also trigger change event for dropdown
              const changeEvent = new Event('change', { bubbles: true });
              variantSelect.dispatchEvent(changeEvent);
            }
          }
        }
      }
    });
  }

  // Quick View Image Zoom Handler - Now handled by product-gallery-zoom snippet
  // The snippet uses document-level event delegation so it works automatically
  function initQuickViewImageZoom(modal) {
    // No longer needed - product-gallery-zoom snippet handles everything via event delegation
    return;
  }

  // openQuickView is now provided by assets/quick-view.js (shared implementation)

  // Quick view button handler
  document.addEventListener('click', function(e) {
    const button = e.target.closest('[data-quick-view-button]');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    const productUrl = button.getAttribute('data-product-url');
    if (!productUrl) return;

    if (window.openQuickView) {
      window.openQuickView(productUrl);
    }
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // Optimized: Event delegation, early return
  (function() {
    'use strict';
    const faqSection = document.querySelector('.faq-section');
    if (!faqSection) return;

    document.addEventListener('click', function(e) {
      const question = e.target.closest('.faq-item__question');
      if (!question || !faqSection.contains(question)) return;

      const isExpanded = question.getAttribute('aria-expanded') === 'true';
      const answer = question.nextElementSibling;
      const allQuestions = faqSection.querySelectorAll('.faq-item__question');

      // Close all other FAQs
      allQuestions.forEach(q => {
        if (q !== question) {
          q.setAttribute('aria-expanded', 'false');
          const ans = q.nextElementSibling;
          if (ans) ans.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle current FAQ
      const newState = !isExpanded;
      question.setAttribute('aria-expanded', newState);
      if (answer) answer.setAttribute('aria-expanded', newState);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-main"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';
    // Mobile menu is handled by header.liquid's event delegation
    // This file doesn't need separate mobile menu handling
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    try {
      'use strict';

      // Expose initialization status so we can provide a safe fallback elsewhere if needed.
      // We intentionally set "booting" first, and only flip to "ready" once listeners are attached.
      window.__catchyHeader = window.__catchyHeader || {};
      window.__catchyHeader.status = 'booting';
    
      // Cache DOM references to avoid repeated queries
      const header = document.querySelector('[data-header]');
      const mobileMenu = document.querySelector('[data-mobile-menu]');
      const headerMain = document.querySelector('.header__main');

      // Cache frequently accessed element collections
      let cachedMobileSearchElements = null;
      let cachedOverflowMoreElements = null;
      let cachedMobileMenuToggles = null;
      
      // Helper to refresh cached elements (call when DOM changes)
      function refreshCachedElements() {
        cachedMobileSearchElements = document.querySelectorAll('[data-mobile-search]');
        cachedOverflowMoreElements = document.querySelectorAll('[data-overflow-more]');
        cachedMobileMenuToggles = document.querySelectorAll('[data-mobile-menu-toggle]');
      }
      
      // Initial cache
      refreshCachedElements();
      
      // Helper: Get current header bottom position (cached)
      function getHeaderBottom() {
        // When at top of page, calculate from the entire header element
        // This ensures we get the full height including utility bar, main section, and navigation
        if (header) {
          const headerRect = header.getBoundingClientRect();
          const bottom = headerRect.bottom;
          
          // getBoundingClientRect() returns viewport-relative position
          // For position: fixed elements, we need the viewport-relative bottom
          // When header is at top (top <= 5px), bottom should equal header height
          if (headerRect.top <= 5) {
            // Header is at/near top of viewport
            // Use getBoundingClientRect().bottom which gives accurate viewport position
            if (bottom > 0) {
              return bottom;
            } else {
              // Fallback: use offsetHeight (includes padding, border, but not margin)
              return header.offsetHeight;
            }
          } else {
            // Header has some scroll offset, use bottom position
            if (bottom > 0) {
              return bottom;
            } else {
              // Fallback: calculate from scroll position + height
              return headerRect.top + header.offsetHeight;
            }
          }
        }
        // Fallback to headerMain if header not found
        if (headerMain) {
          const mainRect = headerMain.getBoundingClientRect();
          return mainRect.bottom > 0 ? mainRect.bottom : headerMain.offsetHeight;
        }
        return 0;
      }
      
      // Helper: Update all toggle buttons' aria-expanded (using cached elements)
      function updateToggleAria(selectors, state) {
        selectors.forEach(function(selector) {
          let toggles;
          if (selector === '[data-mobile-menu-toggle]') {
            toggles = cachedMobileMenuToggles;
          } else {
            toggles = document.querySelectorAll(selector);
          }
          toggles.forEach(function(toggle) {
            toggle.setAttribute('aria-expanded', String(state));
          });
        });
      }
      
      // Helper: Close all menus (using cached elements)
      function closeAllMenus() {
        if (mobileMenu) mobileMenu.dataset.mobileMenuOpen = 'false';
        if (cachedMobileSearchElements) {
          cachedMobileSearchElements.forEach(function(search) {
            search.dataset.mobileSearchOpen = 'false';
            search.setAttribute('data-mobile-search-open', 'false');
            search.setAttribute('aria-hidden', 'true');
            search.removeAttribute('style');
          });
        }
        closeOverflowMenus();
        updateToggleAria(['[data-mobile-menu-toggle]'], false);
      }

      // Overflow "More" menu helpers (desktop navigation) - using cached elements
      function closeOverflowMenus() {
        if (cachedOverflowMoreElements) {
          cachedOverflowMoreElements.forEach(function(moreItem) {
            moreItem.dataset.moreOpen = 'false';
            const toggle = moreItem.querySelector('[data-overflow-more-toggle]');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
            const dropdown = moreItem.querySelector('[data-overflow-more-dropdown]');
            if (dropdown) dropdown.setAttribute('aria-hidden', 'true');
          });
        }
      }

      function getOverflowFocusable(moreItem) {
        const list = moreItem ? moreItem.querySelector('[data-overflow-more-list]') : null;
        if (!list) return [];
        return Array.from(list.querySelectorAll('a[href]')).filter(function(a) {
          return !a.closest('[hidden]') && a.offsetParent !== null;
        });
      }

      function openOverflowMenu(moreItem, focusTarget) {
        if (!moreItem) return;
        const toggle = moreItem.querySelector('[data-overflow-more-toggle]');
        const dropdown = moreItem.querySelector('[data-overflow-more-dropdown]');
        moreItem.dataset.moreOpen = 'true';
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        if (dropdown) dropdown.setAttribute('aria-hidden', 'false');

        // Focus management
        const items = getOverflowFocusable(moreItem);
        if (!items.length) return;

        if (focusTarget === 'last') {
          items[items.length - 1].focus();
        } else if (typeof focusTarget === 'number') {
          const idx = Math.max(0, Math.min(items.length - 1, focusTarget));
          items[idx].focus();
        } else {
          items[0].focus();
        }
      }

      function buildOverflowEntryFromMenuItem(menuItem) {
        const entries = [];
        const parentLink = menuItem.querySelector('.header__menu-link');
        if (!parentLink) return entries;

        // Extract label without arrow icon text
        const parentText = (parentLink.childNodes[0] && parentLink.childNodes[0].textContent)
          ? parentLink.childNodes[0].textContent.trim()
          : parentLink.textContent.trim();

        const parentHref = parentLink.getAttribute('href') || '#';
        const parentActive = parentLink.classList.contains('header__menu-link--active');

        function addLink(text, href, isActive, isChild) {
          const li = document.createElement('li');
          li.className = 'header__dropdown-item';
          const a = document.createElement('a');
          a.className = 'header__dropdown-link' + (isActive ? ' header__dropdown-link--active' : '') + (isChild ? ' header__dropdown-link--child' : '');
          a.href = href;
          a.textContent = text;
          a.setAttribute('role', 'menuitem');
          if (isActive) a.setAttribute('aria-current', 'page');
          li.appendChild(a);
          entries.push(li);
        }

        // Add the parent
        addLink(parentText, parentHref, parentActive, false);

        // If parent has dropdown children, add them indented
        const childLinks = menuItem.querySelectorAll('.header__dropdown-link');
        if (childLinks && childLinks.length) {
          childLinks.forEach(function(child) {
            addLink(
              child.textContent.trim(),
              child.getAttribute('href') || '#',
              child.classList.contains('header__dropdown-link--active'),
              true
            );
          });
        }

        return entries;
      }

      function initOverflowNav(nav) {
        if (!nav) return;
        const container = nav.querySelector('.header__navigation-container');
        const list = nav.querySelector('.header__menu-list');
        const moreItem = nav.querySelector('[data-overflow-more]');
        if (!container || !list || !moreItem) return;

        // Desktop only: on smaller screens the header switches to mobile navigation
        if (window.matchMedia && !window.matchMedia('(min-width: 991px)').matches) {
          nav.dataset.overflowReady = 'false';
          moreItem.hidden = true;
          // Enable wrapping for tablet/mobile
          list.style.flexWrap = 'wrap';
          list.style.overflow = 'visible';
          return;
        }

        // Only run when measurable (avoid 0-width when hidden)
        const containerWidth = container.getBoundingClientRect().width;
        if (!containerWidth) return;

        // Enable single-line mode for JS-managed overflow
        nav.dataset.overflowReady = 'true';

        const moreList = moreItem.querySelector('[data-overflow-more-list]');
        const moreToggle = moreItem.querySelector('[data-overflow-more-toggle]');
        const moreDropdown = moreItem.querySelector('[data-overflow-more-dropdown]');

        // Reset
        closeOverflowMenus();
        if (moreList) moreList.innerHTML = '';
        Array.from(list.children).forEach(function(li) {
          if (li !== moreItem) li.hidden = false;
        });
        moreItem.hidden = true;
        if (moreToggle) moreToggle.setAttribute('aria-expanded', 'false');
        if (moreDropdown) moreDropdown.setAttribute('aria-hidden', 'true');

        // Wire aria-controls once (generate stable-ish id per nav)
        if (moreToggle && moreDropdown) {
          if (!moreDropdown.id) {
            moreDropdown.id = 'overflow-more-dropdown-' + Math.random().toString(36).slice(2, 10);
          }
          moreToggle.setAttribute('aria-controls', moreDropdown.id);
        }

        // If it fits without "More", we're done
        if (list.scrollWidth <= list.clientWidth) {
          return;
        }

        // Check if we have a reasonable number of items - if so, try wrapping instead
        const totalItems = list.children.length - (moreItem.hidden ? 0 : 1); // Exclude "More" if it's there
        const overflowRatio = list.scrollWidth / list.clientWidth;

        // If overflow is minimal (< 1.5x) and we have 6 or fewer items, try wrapping first
        if (overflowRatio < 1.5 && totalItems <= 6) {
          nav.dataset.overflowReady = 'false';
          moreItem.hidden = true;
          list.style.flexWrap = 'wrap';
          list.style.overflow = 'visible';
          return;
        }

        // Show "More" and start moving items from the end until it fits
        moreItem.hidden = false;
        const candidates = Array.from(list.children).filter(function(li) {
          return li !== moreItem;
        });

        const moved = [];
        let safety = 0;
        while (list.scrollWidth > list.clientWidth && safety < 50) {
          // Find last visible candidate
          let lastVisible = null;
          for (let i = candidates.length - 1; i >= 0; i--) {
            if (!candidates[i].hidden) {
              lastVisible = candidates[i];
              break;
            }
          }
          if (!lastVisible) break;
          lastVisible.hidden = true;
          moved.unshift(lastVisible); // preserve original left-to-right order in dropdown
          safety++;
        }

        // If we still overflow even after hiding everything, fall back to wrapping
        const anyVisible = candidates.some(li => !li.hidden);
        if (!anyVisible || list.scrollWidth > list.clientWidth) {
          // Try wrapping the menu first before giving up
          nav.dataset.overflowReady = 'false';
          candidates.forEach(li => (li.hidden = false));
          moreItem.hidden = true;
          if (moreList) moreList.innerHTML = '';

          // Enable wrapping on the menu list
          list.style.flexWrap = 'wrap';
          list.style.overflow = 'visible';

          // If it still overflows after wrapping, we might need the "More" button
          // But for now, let it wrap naturally
          return;
        }

        // Build dropdown content (grouped, with separators)
        if (moreList) {
          moreList.innerHTML = '';
          moved.forEach(function(item, idx) {
            if (idx > 0) {
              const sep = document.createElement('li');
              sep.className = 'header__dropdown-separator';
              sep.setAttribute('role', 'separator');
              moreList.appendChild(sep);
            }
            const entries = buildOverflowEntryFromMenuItem(item);
            entries.forEach(function(entry) {
              moreList.appendChild(entry);
            });
          });
        }

        // If we didn't move anything, hide "More"
        if (!moreList || !moreList.children.length) {
          moreItem.hidden = true;
        }
      }
      
      // Mobile menu toggle handler
      function handleMenuToggle(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        
        // Use mobile menu
        let targetMenu;
        let toggleSelectors;
        
        if (mobileMenu) {
          // Use mobile menu
          targetMenu = mobileMenu;
          toggleSelectors = ['[data-mobile-menu-toggle]'];
        } else {
          return; // No menu available
        }

        const isOpen = targetMenu.dataset.mobileMenuOpen === 'true';
        const newState = !isOpen;
        
        // Close other menus when opening
        if (newState) {
          closeAllMenus();
        }
        
        // Position menu below header (set BEFORE opening to prevent flash at top)
        if (newState) {
          // Calculate position synchronously BEFORE toggling menu state
          let menuTop = 0;
          const headerBottom = getHeaderBottom();
          
          if (headerBottom > 0) {
            menuTop = headerBottom;
          } else {
            // Fallback: calculate from header element directly
            if (header) {
              const headerRect = header.getBoundingClientRect();
              // When at top of page (within 10px), use offsetHeight for reliability
              // offsetHeight is more reliable than getBoundingClientRect when at top
              if (headerRect.top <= 10) {
                // Header is at/near top, use its full height
                menuTop = header.offsetHeight;
              } else {
                // Header has scroll offset, calculate from position + height
                menuTop = headerRect.top + header.offsetHeight;
              }
            } else if (headerMain) {
              const mainRect = headerMain.getBoundingClientRect();
              menuTop = mainRect.top <= 10 ? headerMain.offsetHeight : (mainRect.bottom > 0 ? mainRect.bottom : headerMain.offsetHeight);
            } else {
              menuTop = 80; // Safe fallback
            }
          }
          
          // Final safety check: ensure we have a valid positive value
          if (menuTop <= 0) {
            menuTop = header ? header.offsetHeight : (headerMain ? headerMain.offsetHeight : 80);
          }
          
          // Set position BEFORE opening menu to prevent animation from top: 0
          // Temporarily disable transition to prevent animation
          const originalTransition = targetMenu.style.transition;
          targetMenu.style.transition = 'none';
          targetMenu.style.setProperty('top', menuTop + 'px', 'important');
          
          // Now toggle the menu state
          targetMenu.setAttribute('data-mobile-menu-open', String(newState));
          targetMenu.dataset.mobileMenuOpen = String(newState);
          
          // Re-enable transition after menu is opened (for smooth closing animation)
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              targetMenu.style.transition = originalTransition || '';
            });
          });
          
        } else {
          // Reset position when closing
          targetMenu.style.removeProperty('top');
          targetMenu.setAttribute('data-mobile-menu-open', String(newState));
          targetMenu.dataset.mobileMenuOpen = String(newState);
        }
        
        // Update toggle buttons
        updateToggleAria(toggleSelectors, newState);
      }
      
      
        // Mobile search handler for all search icons
        document.addEventListener('click', function(e) {
          const anySearchToggle = e.target.closest('[data-mobile-search-toggle]');
          if (anySearchToggle) {
            e.preventDefault();

            // Find the overlay
            let searchOverlay = document.querySelector('[data-mobile-search]');

            if (searchOverlay) {
              // Toggle the search overlay
              const isCurrentlyOpen = searchOverlay.getAttribute('data-mobile-search-open') === 'true';
              const shouldOpen = !isCurrentlyOpen;

              // Update overlay state
              searchOverlay.setAttribute('data-mobile-search-open', shouldOpen ? 'true' : 'false');
              searchOverlay.dataset.mobileSearchOpen = shouldOpen ? 'true' : 'false';
              searchOverlay.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');

              if (shouldOpen) {
                // Position the overlay
                const top = getHeaderBottom();
                document.documentElement.style.setProperty('--header-search-top', top + 'px');

                // Move overlay to body to escape any parent constraints
                if (searchOverlay.parentNode !== document.body) {
                  document.body.appendChild(searchOverlay);
                }

                // Force visibility with maximum priority inline styles
                searchOverlay.style.display = 'block !important';
                searchOverlay.style.position = 'fixed !important';
                searchOverlay.style.top = top + 'px !important';
                searchOverlay.style.left = '0 !important';
                searchOverlay.style.right = '0 !important';
                searchOverlay.style.bottom = 'auto !important';
                searchOverlay.style.width = '100vw !important';
                searchOverlay.style.height = 'auto !important';
                searchOverlay.style.zIndex = '99999 !important';
                searchOverlay.style.background = 'white !important';
                searchOverlay.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3) !important';
              } else {
                // Clear inline styles when closing
                searchOverlay.style.display = '';
                searchOverlay.style.position = '';
                searchOverlay.style.top = '';
                searchOverlay.style.left = '';
                searchOverlay.style.right = '';
                searchOverlay.style.bottom = '';
                searchOverlay.style.width = '';
                searchOverlay.style.height = '';
                searchOverlay.style.zIndex = '';
                searchOverlay.style.background = '';
                searchOverlay.style.boxShadow = '';
              }

              // Update all toggle buttons
              const allToggles = document.querySelectorAll('[data-mobile-search-toggle]');
              allToggles.forEach(toggle => {
                toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
              });
            } else {
              console.log('ERROR: No search overlay found!');
            }
          }
        });

        // Mobile search clear button handler
        document.addEventListener('click', function(e) {
          const clearButton = e.target.closest('[data-mobile-search-clear]');
          if (clearButton) {
            e.preventDefault();
            // Find the associated search input
            const searchForm = clearButton.closest('.header__mobile-search-form');
            if (searchForm) {
              const searchInput = searchForm.querySelector('input[type="search"]');
              if (searchInput) {
                searchInput.value = '';
                searchInput.focus();
              }
            }
          }
        });

        // Event delegation for all menu toggles (single, unified handler)
        document.addEventListener('click', function(e) {
          const moreToggle = e.target.closest('[data-overflow-more-toggle]');
          if (moreToggle) {
            e.preventDefault();
            e.stopPropagation();
          const moreItem = moreToggle.closest('[data-overflow-more]');
          if (moreItem) {
            const isOpen = moreItem.dataset.moreOpen === 'true';
            if (isOpen) {
              closeOverflowMenus();
              moreToggle.focus();
            } else {
              closeOverflowMenus();
              openOverflowMenu(moreItem);
            }
          }
          return;
        }

        const mobileToggle = e.target.closest('[data-mobile-menu-toggle]');

        if (mobileToggle) {
          handleMenuToggle(e);
        }
        
        // Close overflow dropdown if clicking outside it
        const openMore = document.querySelector('[data-overflow-more][data-more-open="true"]');
        if (openMore) {
          const clickedInsideMore = e.target.closest('[data-overflow-more]');
          if (!clickedInsideMore) {
            closeOverflowMenus();
          }
        }
      }, true);

      // Escape closes the overflow "More" dropdown
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          const openMore = document.querySelector('[data-overflow-more][data-more-open="true"]');
          if (openMore) {
            closeOverflowMenus();
            const toggle = openMore.querySelector('[data-overflow-more-toggle]');
            if (toggle) toggle.focus();
          }
        }
      });

      // Keyboard navigation for overflow dropdown
      document.addEventListener('keydown', function(e) {
        const openMore = document.querySelector('[data-overflow-more][data-more-open="true"]');
        const active = document.activeElement;

        // Toggle keyboard behavior even when closed
        const toggle = active && active.closest ? active.closest('[data-overflow-more-toggle]') : null;
        if (toggle) {
          if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const item = toggle.closest('[data-overflow-more]');
            if (item) {
              closeOverflowMenus();
              openOverflowMenu(item, 'first');
            }
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const item = toggle.closest('[data-overflow-more]');
            if (item) {
              closeOverflowMenus();
              openOverflowMenu(item, 'last');
            }
          }
          return;
        }

        if (!openMore) return;
        const withinMenu = active && active.closest ? active.closest('[data-overflow-more]') : null;
        if (!withinMenu) return;

        const items = getOverflowFocusable(openMore);
        if (!items.length) return;
        const idx = items.indexOf(active);

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          items[(idx + 1 + items.length) % items.length].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          items[(idx - 1 + items.length) % items.length].focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          items[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          items[items.length - 1].focus();
        }
      });

      // Use AbortController for event listener cleanup
      const headerAbortController = new AbortController();
      const headerSignal = headerAbortController.signal;

      // Close overflow menu if focus moves outside (keyboard tabbing) - using cached elements
      document.addEventListener('focusin', function(e) {
        if (!cachedOverflowMoreElements) return;
        const openMore = Array.from(cachedOverflowMoreElements).find(function(item) {
          return item.dataset.moreOpen === 'true';
        });
        if (!openMore) return;
        const inside = e.target && e.target.closest ? e.target.closest('[data-overflow-more]') : null;
        if (!inside) closeOverflowMenus();
      }, { signal: headerSignal });

      // Initialize overflow nav (desktop) and reflow on resize - cache navs
      const overflowNavs = document.querySelectorAll('[data-overflow-nav]');
      function refreshOverflowNavs() {
        overflowNavs.forEach(function(nav) {
          initOverflowNav(nav);
        });
        // Refresh cached elements after DOM changes
        refreshCachedElements();
      }

      const debouncedRefresh = (window.ThemeUtils && window.ThemeUtils.debounce)
        ? window.ThemeUtils.debounce(refreshOverflowNavs, 100)
        : function() { setTimeout(refreshOverflowNavs, 0); };

      window.addEventListener('resize', debouncedRefresh, { passive: true, signal: headerSignal });
      // Run after initial layout
      setTimeout(refreshOverflowNavs, 0);
      
      // Improve dropdown hover behavior - keep dropdown open when moving between menu item and dropdown
      (function initDropdownHoverBehavior() {
        let dropdownTimeout;

        function showDropdown(menuItem) {
          const dropdown = menuItem.querySelector('.header__dropdown');
          if (dropdown) {
            clearTimeout(dropdownTimeout);
            dropdown.style.opacity = '1';
            dropdown.style.visibility = 'visible';
            dropdown.style.transform = 'translateY(0)';
            dropdown.style.pointerEvents = 'auto';
          }
        }

        function hideDropdown(menuItem) {
          const dropdown = menuItem.querySelector('.header__dropdown');
          if (dropdown) {
            dropdownTimeout = setTimeout(() => {
              dropdown.style.opacity = '0';
              dropdown.style.visibility = 'hidden';
              dropdown.style.transform = 'translateY(-8px)';
              dropdown.style.pointerEvents = 'none';
            }, 150); // 150ms delay to allow mouse movement
          }
        }

        // Add hover listeners to menu items with dropdowns
        document.querySelectorAll('.header__menu-item:has(.header__dropdown)').forEach(menuItem => {
          menuItem.addEventListener('mouseenter', () => showDropdown(menuItem));
          menuItem.addEventListener('mouseleave', () => hideDropdown(menuItem));

          const dropdown = menuItem.querySelector('.header__dropdown');
          if (dropdown) {
            dropdown.addEventListener('mouseenter', () => showDropdown(menuItem));
            dropdown.addEventListener('mouseleave', () => hideDropdown(menuItem));
          }
        });
      })();

      // Header search toggle (simple + robust)
      (function initHeaderSearchToggle() {
        let overlay = document.querySelector('.header__search--expanded-hidden [data-mobile-search]') || document.querySelector('[data-mobile-search]');
        if (!overlay) {
          console.log('Search toggle: no overlay found');
          return;
        }
        window.__catchyHeader = window.__catchyHeader || {};
        window.__catchyHeader.searchToggle = 'bound';
        let lastToggle = null;

        // Ensure consistent initial state (attribute + dataset)
        function ensureOverlayState(el) {
          if (!el) return;
          if (!el.getAttribute('data-mobile-search-open')) {
            el.setAttribute('data-mobile-search-open', 'false');
          }
          if (!el.dataset.mobileSearchOpen) {
            el.dataset.mobileSearchOpen = el.getAttribute('data-mobile-search-open') || 'false';
          }
          if (!el.getAttribute('aria-hidden')) {
            el.setAttribute('aria-hidden', 'true');
          }
        }

        ensureOverlayState(overlay);

        function setOpen(open) {
          const next = open ? 'true' : 'false';
          overlay.setAttribute('data-mobile-search-open', next);
          overlay.dataset.mobileSearchOpen = next;
          overlay.setAttribute('aria-hidden', open ? 'false' : 'true');

          // Keep the toggle button a11y state in sync
          const overlayId = overlay && overlay.id ? overlay.id : null;
          const allToggles = Array.from(document.querySelectorAll('[data-mobile-search-toggle]'));
          const relevantToggles = overlayId
            ? allToggles.filter(t => t.getAttribute('aria-controls') === overlayId)
            : allToggles;
          (relevantToggles.length ? relevantToggles : allToggles).forEach(function(t) {
            t.setAttribute('aria-expanded', next);
          });

          if (open) {
            // Position overlay below whichever header is currently visible
            const top = getHeaderBottom();
            document.documentElement.style.setProperty('--header-search-top', top + 'px');

            // Close other menus but keep search open
            if (mobileMenu) mobileMenu.dataset.mobileMenuOpen = 'false';

            const input = overlay.querySelector('.header__mobile-search-input');
            if (input) setTimeout(function() { input.focus(); }, 50);
          } else {
            document.documentElement.style.removeProperty('--header-search-top');
            if (lastToggle && lastToggle.focus) {
              setTimeout(function() { lastToggle.focus(); }, 0);
            }
          }
        }

        function isOpen() {
          return overlay.getAttribute('data-mobile-search-open') === 'true' || overlay.dataset.mobileSearchOpen === 'true';
        }

        document.addEventListener('click', function(e) {
          const toggle = e.target && e.target.closest ? e.target.closest('[data-mobile-search-toggle]') : null;
          const closeBtn = e.target && e.target.closest ? e.target.closest('[data-mobile-search-close]') : null;

          if (toggle) {
            e.preventDefault();
            lastToggle = toggle;
            const controlsId = toggle.getAttribute('aria-controls');
            const controlled = controlsId ? document.getElementById(controlsId) : null;
            if (controlled && controlled.hasAttribute('data-mobile-search')) {
              // Switch overlay reference if needed
              overlay = controlled;
              ensureOverlayState(overlay);
            }
            setOpen(!isOpen());
            return;
          }

          if (closeBtn && overlay.contains(closeBtn)) {
            e.preventDefault();
            setOpen(false);
            return;
          }

          // Click outside closes
          if (isOpen()) {
            const clickedInside = overlay.contains(e.target);
            if (!clickedInside) setOpen(false);
          }
        }, true);

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && isOpen()) {
            setOpen(false);
          }
        });
      })();
      
      // Mobile submenu toggles
      if (mobileMenu) {
        mobileMenu.addEventListener('click', function(e) {
          const toggle = e.target.closest('[data-mobile-submenu-toggle]');
          if (toggle) {
            e.preventDefault();
            const menuItem = toggle.closest('.header__mobile-menu-item');
            if (menuItem) {
              const isOpen = menuItem.dataset.mobileSubmenuOpen === 'true';
              menuItem.dataset.mobileSubmenuOpen = String(!isOpen);
            }
          }

          // Level 2 submenu toggle
          const toggleLevel2 = e.target.closest('[data-mobile-submenu-level2-toggle]');
          if (toggleLevel2) {
            e.preventDefault();
            const submenuItem = toggleLevel2.closest('.header__mobile-submenu-item');
            if (submenuItem) {
              const isOpen = submenuItem.dataset.mobileSubmenuLevel2Open === 'true';
              submenuItem.dataset.mobileSubmenuLevel2Open = String(!isOpen);
            }
          }
        });
      }
      
      // Auto-collapse menus on scroll
      let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let collapseTicking = false;
      
      function handleMenuCollapseOnScroll() {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDelta = Math.abs(currentScrollTop - lastScrollTop);
        
        if (scrollDelta > 10) {
          closeAllMenus();
        }
        
        lastScrollTop = currentScrollTop;
      }
      
      function onMenuCollapseScroll() {
        if (!collapseTicking) {
          window.requestAnimationFrame(function() {
            handleMenuCollapseOnScroll();
            collapseTicking = false;
          });
          collapseTicking = true;
        }
      }
      
      window.addEventListener('scroll', onMenuCollapseScroll, { passive: true, signal: headerSignal });

      // Cleanup on page unload
      window.addEventListener('beforeunload', function() {
        headerAbortController.abort();
      });

      window.__catchyHeader.status = 'ready';
    } catch (error) {
      window.__catchyHeader = window.__catchyHeader || {};
      window.__catchyHeader.status = 'error';
    }
  })();

  // Smart Sticky Header - Enhanced scroll behavior
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (!header || !headerWrapper) {
      console.log('Smart header: Elements not found', {
        header: !!header,
        headerWrapper: !!headerWrapper
      });
      return;
    }

    console.log('Smart header: Initialized successfully');

    let lastScrollY = window.scrollY;
    let isHidden = false;

    function updateHeader() {
      const currentScrollY = window.scrollY;
      const isAtTop = currentScrollY < 10;
      const hasScrolledPastBenefitBar = currentScrollY > 40;

      // Apply scrolled styling when past benefit bar (40px) - snaps header to top
      if (hasScrolledPastBenefitBar) {
        headerWrapper.classList.add('header-wrapper--scrolled');
      } else {
        headerWrapper.classList.remove('header-wrapper--scrolled');
      }

      // Apply scrolled styling when not at top (matches CSS .header--scrolled rule)
      if (currentScrollY > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      // Smart hide/show logic - only after header has snapped to top
      if (isAtTop) {
        // Always show header when at the very top
        if (isHidden) {
          headerWrapper.classList.remove('header--hidden');
          isHidden = false;
        }
      } else if (hasScrolledPastBenefitBar) {
        // Only apply hide/show logic after header has snapped to top
        if (currentScrollY > lastScrollY && !isHidden) {
          // Hide header immediately when scrolling down (after benefit bar snap)
          headerWrapper.classList.add('header--hidden');
          isHidden = true;
        } else if (currentScrollY < lastScrollY && isHidden) {
          // Show header instantly when scrolling up
          headerWrapper.classList.remove('header--hidden');
          isHidden = false;
        }
      } else {
        // Before benefit bar snap point, ensure header is visible
        if (isHidden) {
          headerWrapper.classList.remove('header--hidden');
          isHidden = false;
        }
      }

      lastScrollY = currentScrollY;
    }

    // Listen for scroll events on window (ensures we track window.scrollY correctly)
    window.addEventListener('scroll', updateHeader, { passive: true });

    // Initial check to set correct state on page load
    updateHeader();
    console.log('Smart header: Setup complete - ready for scroll events');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Sticky mobile add-to-cart bar functionality
  const stickyBar = document.querySelector('[data-sticky-mobile-bar]');
  const stickyButton = document.querySelector('[data-sticky-add-to-cart]');
  const addToCartForm = document.querySelector('.product-form');

  if (!stickyBar || !stickyButton || !addToCartForm) return;

  // Function to check if we should show the sticky bar
  function checkStickyBarVisibility() {
    if (window.innerWidth > 750) return; // Only show on mobile

    const formRect = addToCartForm.getBoundingClientRect();
    const isPastForm = formRect.bottom < 0; // Form is above viewport

    if (isPastForm && !stickyBar.classList.contains('product-form__sticky-mobile--visible')) {
      stickyBar.classList.add('product-form__sticky-mobile--visible');
    } else if (!isPastForm && stickyBar.classList.contains('product-form__sticky-mobile--visible')) {
      stickyBar.classList.remove('product-form__sticky-mobile--visible');
    }
  }

  // Handle sticky button click
  stickyButton.addEventListener('click', function(e) {
    e.preventDefault();

    // Find the main add to cart button and click it
    const mainButton = addToCartForm.querySelector('.product-form__submit');
    if (mainButton && !mainButton.disabled) {
      mainButton.click();
    }
  });

  // Check visibility on scroll and resize
  window.addEventListener('scroll', checkStickyBarVisibility, { passive: true });
  window.addEventListener('resize', checkStickyBarVisibility);

  // Initial check
  checkStickyBarVisibility();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  // Search page filter functionality
  (function() {
    'use strict';
    
    const filterTabs = document.querySelectorAll('.search-page__filter-tab');
    const resultCards = document.querySelectorAll('.search-result-card[data-result-type]');
    if (filterTabs.length === 0 || resultCards.length === 0) return;
    
    // Use event delegation for better performance
    document.addEventListener('click', function(e) {
      const tab = e.target.closest('.search-page__filter-tab');
      if (!tab) return;
      
      const filterType = tab.dataset.filterType;
      filterTabs.forEach(t => t.classList.remove('search-page__filter-tab--active'));
      tab.classList.add('search-page__filter-tab--active');
      
      resultCards.forEach(card => {
        card.classList.toggle('search-result-card--hidden', filterType !== 'all' && card.dataset.resultType !== filterType);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
